import React, { useContext, useEffect, useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";
import { getFormattedDateURL } from "components/atoms/dateTime/GetFormattedDate";
import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage } from "api/definitions";

const sortObjectAlphabetically = (obj) => {
  // 1. Convert to Array
  const sortedEntries = Object.entries(obj).sort(([keyA], [keyB]) =>
    keyA.localeCompare(keyB)
  );

  // 2. Recreate the Object
  return Object.fromEntries(sortedEntries);
};

const ReportWeekReservationTable = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setIsLoaded(false);
    const dateURL = getFormattedDateURL(props.date);
    const idUnit = props.idUnit ? "&idUnidade=" + props.idUnit : "";
    const idDivision = props.idDivision ? "&idDivisao=" + props.idDivision : "";
    const idDiscipline = props.idDiscipline
      ? "&idDisciplina=" + props.idDiscipline
      : "";
    const idActivityType = props.idActivityType
      ? "&idAtividadeTipo=" + props.idActivityType
      : "";
    const fullURL = `relatorio/aulasSemana?date=${dateURL}${idActivityType}${idUnit}${idDivision}${idDiscipline}`;

    instance
      .get(fullURL)
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        setItems(result);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [
    props.date,
    props.idUnit,
    props.idDivision,
    props.idDiscipline,
    props.idActivityType,
    snackContext,
  ]);

  if (!isLoaded) {
    return <CircularProgress />;
  } else {
    const len = Object.keys(items);
    if (len.length === 0) {
      return <Typography color="error">Vazio.</Typography>;
    } else {
      let tables = [];
      for (const [keyUnit, valueUnit] of Object.entries(items)) {
        let rows = [];
        const objects = [valueUnit];
        //console.log(objects);
        const combinedObject = objects.reduce((acc, obj) => {
          return Object.assign(acc, ...Object.values(obj));
        }, {});
        const sortedObject = sortObjectAlphabetically(combinedObject);
        for (const [keyActivity, valueActivity] of Object.entries(
          sortedObject
        )) {
          let reservationRow = [];
          const hours = valueActivity.horarios;
          hours.forEach((element) => {
            reservationRow.push(
              <Typography
                key={element.idReserva}
              >{`${element.diaDaSemana} (${element.inicio} - ${element.fim}) ${element.Bloco} - ${element.Local}`}</Typography>
            );
          });

          rows.push(
            <StyledTableRow key={keyActivity}>
              <StyledTableCell>{valueActivity.nomeAtividade}</StyledTableCell>
              <StyledTableCell>{valueActivity.codDisciplina}</StyledTableCell>
              <StyledTableCell>{valueActivity.solicitante}</StyledTableCell>
              <StyledTableCell>{reservationRow}</StyledTableCell>
            </StyledTableRow>
          );
        }

        let keyText = "";
        console.log(keyUnit);
        switch (keyUnit) {
          case "ICEx":
            keyText = "ICEx - Atividades do tipo Ensalamento";
            break;

          case "ICHS":
            keyText = "ICHS - Atividades do tipo Ensalamento";
            break;

          default:
            keyText = "Atividades sem ser do tipo Ensalamento";
            break;
        }

        tables.push(
          <Box key={keyUnit}>
            <Typography variant="h6">{keyText}</Typography>
            <Box sx={{ mb: 2 }}>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="tabela">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Atividade</StyledTableCell>
                      <StyledTableCell>Código</StyledTableCell>
                      <StyledTableCell>Responsável</StyledTableCell>
                      <StyledTableCell>Reservas</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>{rows}</TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        );
      }

      return tables;
    }
  }
};

export default ReportWeekReservationTable;
